import { render, staticRenderFns } from "./LikerItem.vue?vue&type=template&id=7dd5dbf3&"
import script from "./LikerItem.vue?vue&type=script&lang=js&"
export * from "./LikerItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dd5dbf3')) {
      api.createRecord('7dd5dbf3', component.options)
    } else {
      api.reload('7dd5dbf3', component.options)
    }
    module.hot.accept("./LikerItem.vue?vue&type=template&id=7dd5dbf3&", function () {
      api.rerender('7dd5dbf3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/Preview/Post/LikersCount/LikerItem.vue"
export default component.exports